export enum EEnvironment {
	production = 'production',
	development = 'development',
	preview = 'preview'
}
